import type { SVGProps } from "react";
const SvgAlert = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    fontSize="1rem"
    {...props}
  >
    <g fill="#FF073B" clipPath="url(#alert_svg__a)">
      <path d="M12 2.097a2.8 2.8 0 0 1 2.296 1.197l.098.151.003.004 8.47 14.14.006.011a2.8 2.8 0 0 1-2.394 4.2H3.52a2.8 2.8 0 0 1-2.394-4.2l.007-.011 8.47-14.14.002-.004A2.8 2.8 0 0 1 12 2.097m0 1.6a1.2 1.2 0 0 0-1.026.578L2.512 18.4A1.203 1.203 0 0 0 3.538 20.2h16.923a1.2 1.2 0 0 0 1.187-1.203 1.2 1.2 0 0 0-.159-.592l-8.463-14.13-.088-.127a1.2 1.2 0 0 0-.938-.45" />
      <path d="M11.2 13V9a.8.8 0 1 1 1.6 0v4a.8.8 0 1 1-1.6 0M12.01 16.2a.8.8 0 1 1 0 1.6H12a.8.8 0 1 1 0-1.6z" />
    </g>
    <defs>
      <clipPath id="alert_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAlert;
